<ds-accordion-category class="list" [title]="'About KnowYourDrive'" [isOpen]="!recentAction">
  <p class="pad-bottom-20" dsContent [contentPath]="'kydSmartphonePhh.abtToKnowYourDriveText'"></p>
  <p class="pad-bottom-20">
    <span dsContent [contentPath]="'kydSmartphonePhh.initialDiscount'"></span
    ><span class="text" dsContent [contentPath]="'kydSmartphonePhh.savings'"> </span
    ><span class="text" dsContent [contentPath]="'kydSmartphonePhh.safeDriveText'"></span>
  </p>
  <p class="pad-bottom-20">
    <span dsContent [contentPath]="'kydSmartphonePhh.coveragesList'"></span>
  </p>
  <ul class="bullet-list bullet">
    <li dsContent [contentPath]="'kydSmartphonePhh.coverageBullet1'"></li>
    <li dsContent [contentPath]="'kydSmartphonePhh.coverageBullet2'"></li>
    <li dsContent [contentPath]="'kydSmartphonePhh.coverageBullet3'"></li>
    <li dsContent [contentPath]="'kydSmartphonePhh.coverageBullet4'"></li>
  </ul>
  <p class="pad-bottom-20" dsContent [contentPath]="'kydSmartphonePhh.coverageListEnd'"></p>

  <p class="caption pad-bottom-20">
    <span dsContent [contentPath]="'kydSmartphonePhh.programDiscounts'"></span
    ><span dsContent [contentPath]="'kydSmartphonePhh.kydCoverages'"></span>
  </p>

  <p
    class="caption pad-bottom-20"
    dsContent
    [contentPath]="'kydSmartphonePhh.eligibilityDisclaimer'"
  ></p>
</ds-accordion-category>
